/* Compank — busca, contador do carrinho e seletor de veículo */
(function () {
  "use strict";
  var $ = function (s) { return document.querySelector(s); };
  var fmt = window.CompankMoney || "${{amount}}";
  function money(c) { return String(fmt).replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, (c / 100).toFixed(2)); }

  /* ---------- contador do carrinho ---------- */
  var badge = $("#cart-count");
  function syncBadge(n) { if (badge) { badge.textContent = n; badge.classList.toggle("zero", n === 0); } }
  if (badge) syncBadge(parseInt(badge.textContent, 10) || 0);

  /* ---------- busca ---------- */
  var panel = $("#cq-panel"), scrim = $("#cq-scrim"), input = $("#cq-input"), body = $("#cq-body");
  var initial = body ? body.innerHTML : "";
  var open = false, timer = null;

  function setOpen(v) {
    if (!panel) return;
    open = v;
    panel.classList.toggle("on", v);
    if (scrim) scrim.classList.toggle("on", v);
    document.body.style.overflow = v ? "hidden" : "";
    if (v && input) setTimeout(function () { input.focus(); }, 40);
  }
  var btn = $("#btn-search");
  if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); setOpen(true); });
  if (scrim) scrim.addEventListener("click", function () { setOpen(false); });
  var closeBtn = $("#cq-close");
  if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
    var typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement && document.activeElement.tagName);
    if (e.key === "/" && !typing) { e.preventDefault(); setOpen(true); }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen(true); }
  });

  function row(p) {
    var img = p.featured_image && p.featured_image.url
      ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_100x$1$2") + '" alt="" loading="lazy">'
      : "";
    return '<a class="cq-row" href="' + p.url + '">' +
      '<span class="cq-th">' + img + '</span>' +
      '<span class="cq-txt"><span class="cq-t">' + p.title + '</span>' +
      (p.vendor ? '<span class="cq-m">' + p.vendor + '</span>' : "") + '</span>' +
      '<span class="cq-p">' + (p.price ? money(parseInt(p.price, 10)) : "") + '</span></a>';
  }

  if (input) {
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      var all = $("#cq-all");
      if (all) all.href = "/search?q=" + encodeURIComponent(q);
      timer = setTimeout(function () {
        if (q.length < 2) { body.innerHTML = initial; return; }
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
              "&resources[type]=product,collection,page&resources[limit]=8",
              { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d.resources && d.resources.results) || {};
            var out = "";
            if (res.products && res.products.length)
              out += '<div class="cq-lbl">Products</div>' + res.products.map(row).join("");
            if (res.collections && res.collections.length)
              out += '<div class="cq-lbl">Collections</div>' + res.collections.map(function (c) {
                return '<a class="cq-row" href="' + c.url + '"><span class="cq-th"></span>' +
                       '<span class="cq-txt"><span class="cq-t">' + c.title + '</span></span></a>';
              }).join("");
            if (res.pages && res.pages.length)
              out += '<div class="cq-lbl">Pages</div>' + res.pages.map(function (p) {
                return '<a class="cq-row" href="' + p.url + '"><span class="cq-th"></span>' +
                       '<span class="cq-txt"><span class="cq-t">' + p.title + '</span></span></a>';
              }).join("");
            body.innerHTML = out || '<div class="cq-empty">No match for &ldquo;' + q + '&rdquo;.<br>Try a shorter word, or the mount size — like 22.2.</div>';
          })
          .catch(function () {});
      }, 160);
    });
  }

  /* ---------- seletor de veículo ---------- */
  var rb = Array.prototype.slice.call(document.querySelectorAll(".rs-btn"));
  if (rb.length) {
    var KEY = "compank_ride", note = $("#rs-note"), saved = null;
    try { saved = localStorage.getItem(KEY); } catch (err) {}
    if (saved) rb.forEach(function (b) { b.classList.toggle("on", saved === "both" || saved === b.getAttribute("data-ride")); });
    function current() {
      var on = rb.filter(function (b) { return b.classList.contains("on"); });
      return on.length === rb.length ? "both" : (on[0] ? on[0].getAttribute("data-ride") : "both");
    }
    rb.forEach(function (b) {
      b.addEventListener("click", function () {
        var on = rb.filter(function (x) { return x.classList.contains("on"); });
        if (b.classList.contains("on") && on.length === 1) return;
        b.classList.toggle("on");
        var v = current();
        try { localStorage.setItem(KEY, v); } catch (err) {}
        document.documentElement.setAttribute("data-ride", v);
        if (note) note.textContent = v === "both"
          ? "Showing everything that fits either."
          : "Showing what fits a " + v + ".";
      });
    });
    document.documentElement.setAttribute("data-ride", current());
  }
})();


/* ============================================================
   Barra de avisos em carrossel (apenas <=560px)
   As mensagens ja vem no HTML, entao nao ha "flash" de texto
   empilhado antes do JS rodar. Aqui so entra o movimento.
   ============================================================ */
(function () {
  "use strict";
  var BP = 560, HOLD = 3400, SLIDE = 460, H = 34;

  function init() {
    var bar = document.querySelector(".announce");
    if (!bar) return;
    var track = bar.querySelector(".an-track");
    if (!track) return;

    var slides = track.querySelectorAll(".an-slide");
    var n = slides.length - 1;          /* a ultima e o clone da primeira */
    if (n < 2) return;

    var i = 0, timer = null;

    function step() {
      i++;
      track.classList.remove("nomove");
      track.style.transform = "translateY(-" + (i * H) + "px)";
      if (i === n) {
        setTimeout(function () {
          track.classList.add("nomove");
          track.style.transform = "translateY(0)";
          i = 0;
        }, SLIDE + 20);
      }
    }

    var mq = window.matchMedia("(max-width:" + BP + "px)");

    function start() { if (!timer) timer = setInterval(step, HOLD); }
    function stop() {
      clearInterval(timer); timer = null;
      track.classList.add("nomove");
      track.style.transform = "translateY(0)";
      i = 0;
    }
    function sync() { mq.matches ? start() : stop(); }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { clearInterval(timer); timer = null; } else { sync(); }
    });

    if (mq.addEventListener) mq.addEventListener("change", sync);
    else if (mq.addListener) mq.addListener(sync);

    sync();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();


/* ============================================================
   Menu mobile (gaveta) + acordeoes
   ============================================================ */
(function () {
  "use strict";
  var root  = document.documentElement;
  var btn   = document.getElementById("btn-mnav");
  var nav   = document.getElementById("mnav");
  var scrim = document.getElementById("mnav-scrim");
  var close = document.getElementById("mnav-close");
  if (!btn || !nav) return;

  var lastY = 0;

  function open() {
    lastY = window.scrollY || 0;
    root.classList.add("mnav-open");
    btn.setAttribute("aria-expanded", "true");
    nav.setAttribute("aria-hidden", "false");
    if (close) close.focus();
  }

  function shut() {
    root.classList.remove("mnav-open");
    btn.setAttribute("aria-expanded", "false");
    nav.setAttribute("aria-hidden", "true");
    btn.focus();
  }

  function toggle() {
    root.classList.contains("mnav-open") ? shut() : open();
  }

  btn.addEventListener("click", toggle);
  if (close) close.addEventListener("click", shut);
  if (scrim) scrim.addEventListener("click", shut);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("mnav-open")) shut();
  });

  /* fecha ao navegar para um link de ancora na mesma pagina */
  nav.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest("a") : null;
    if (a && a.getAttribute("href") && a.getAttribute("href").charAt(0) === "#") shut();
  });

  /* se a tela voltar para desktop com a gaveta aberta, desfaz tudo */
  var mq = window.matchMedia("(min-width:1001px)");
  function deskSync() { if (mq.matches && root.classList.contains("mnav-open")) shut(); }
  if (mq.addEventListener) mq.addEventListener("change", deskSync);
  else if (mq.addListener) mq.addListener(deskSync);

  /* --- acordeoes --- */
  var accs = nav.querySelectorAll(".mnav-acc");
  Array.prototype.forEach.call(accs, function (a) {
    a.addEventListener("click", function () {
      var panel = document.getElementById(a.getAttribute("aria-controls"));
      if (!panel) return;
      var isOpen = a.getAttribute("aria-expanded") === "true";

      /* so um painel aberto por vez */
      Array.prototype.forEach.call(accs, function (o) {
        var p = document.getElementById(o.getAttribute("aria-controls"));
        o.setAttribute("aria-expanded", "false");
        if (p) p.classList.remove("on");
      });

      if (!isOpen) {
        a.setAttribute("aria-expanded", "true");
        panel.classList.add("on");
      }
    });
  });

  /* Categorias ja abre expandido: e o motivo de o menu existir */
  var cats = document.getElementById("mnav-cats-btn");
  var catsPanel = document.getElementById("mnav-cats");
  if (cats && catsPanel) {
    cats.setAttribute("aria-expanded", "true");
    catsPanel.classList.add("on");
  }
})();


/* ============================================================
   v27 — setas nos carrosseis (colecoes, Fits both e Kits)
   Cada carrossel ganha um par de botoes. Eles somem quando nao
   ha mais para onde ir daquele lado, e nao aparecem em aparelho
   de toque, onde deslizar ja resolve e a seta so cobriria o
   cartao.
   ============================================================ */
(function () {
  "use strict";

  function build(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = "1";

    var host = document.createElement("div");
    host.className = "rail-host";
    rail.parentNode.insertBefore(host, rail);
    host.appendChild(rail);

    function mk(cls, label) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "rail-btn " + cls;
      b.setAttribute("aria-label", label);
      host.appendChild(b);
      return b;
    }
    var prev = mk("rail-prev", "Previous");
    var next = mk("rail-next", "Next");

    function step() {
      var first = rail.firstElementChild;
      var w = first ? first.getBoundingClientRect().width : 268;
      var gap = 16;
      var n = rail.clientWidth > 700 ? 2 : 1;   /* dois cartoes no desktop */
      return (w + gap) * n;
    }

    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: "smooth" });
    }
    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      prev.classList.toggle("is-off", rail.scrollLeft <= 2);
      next.classList.toggle("is-off", max <= 2 || rail.scrollLeft >= max - 2);
    }
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);

    /* as imagens dos cartoes mudam a largura util depois de carregar */
    if (window.requestAnimationFrame) requestAnimationFrame(sync);
    window.addEventListener("load", sync);
    sync();
  }

  function init() {
    var rails = document.querySelectorAll(".prod-rail, .cat-rail");
    Array.prototype.forEach.call(rails, build);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();


/* ============================================================
   v34 — estado do carrinho compartilhado
   A barra de frete gratis lia o preco do produto, entao nunca
   subia. Agora le o carrinho, e qualquer adicao redesenha a
   barra e o contador do cabecalho sem recarregar a pagina.
   ============================================================ */
window.CompankCart = (function () {
  "use strict";
  var fmt = window.CompankMoney || "${{amount}}";

  function money(cents) {
    return String(fmt).replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, (cents / 100).toFixed(2));
  }

  function paintBar(total) {
    var bar = document.getElementById("shipbar");
    if (!bar) return;
    var thr  = parseInt(bar.getAttribute("data-thr"), 10) || 4900;
    var fill = bar.querySelector("[data-ship-fill]");
    var msg  = bar.querySelector("[data-ship-msg]");
    var num  = bar.querySelector("[data-ship-num]");
    var pct  = Math.min(100, Math.round(total * 100 / thr));

    if (fill) fill.style.width = pct + "%";
    if (total >= thr) {
      bar.classList.add("done");
      if (msg) msg.innerHTML = "<b>Free delivery unlocked</b> on this order";
      if (num) num.textContent = "Over " + money(thr);
    } else {
      bar.classList.remove("done");
      if (msg) msg.innerHTML = "Add <b>" + money(thr - total) + "</b> for free delivery";
      if (num) num.textContent = money(total) + " / " + money(thr);
    }
  }

  function paintBadge(count) {
    var b = document.getElementById("cart-count");
    if (!b) return;
    b.textContent = count;
    b.classList.toggle("zero", count === 0);
  }

  function refresh() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintBar(cart.total_price);
        paintBadge(cart.item_count);
        return cart;
      })
      .catch(function () { return null; });
  }

  function init() { if (document.getElementById("shipbar")) refresh(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  return { money: money, refresh: refresh, paintBar: paintBar, paintBadge: paintBadge };
})();
